module.exports = __webpack_public_path__ + "images/ds-lda-instructor-jeff-li-1-mobile.webp";